import { TimezonesService, ITimezone } from "../../../services/timezone.service";
import * as moment from "moment";
import { Masterdata } from "../../../services/index";

interface IResolve {
    timezone: ITimezone;
    hourCodes: Masterdata[];
}

class TimezonesItemBasicController {

    private resolve: IResolve;
    private timezone: ITimezone;
    hourCodes: Masterdata[];
    private close: any;

    private type: string;
    private types = [
        'Dagelijks', 'Dag van de week', 'Vaste dag elk jaar', 'Eenmalig'
    ]

    private months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    private weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

    private from: {month?: string, day?: number, time?: any, weekDay?: string, year?: string} = {};
    private till: {month?: string, day?: number, time?: any, weekDay?: string, year?: string} = {};

    constructor(
        private TimezonesService: TimezonesService,
        private $state: ng.ui.IStateService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {        
        this.hourCodes = this.resolve.hourCodes;
        if (this.resolve.timezone) {
            this.timezone = this.resolve.timezone;
        } else {
            this.timezone = new ITimezone();
            this.timezone = {
                from: null,
                till: null,
                percentage: 0,
                amount: 0,
                priority: 0,
                dayOfWeek: 0,
                fixedDate: false,
                fixedDateWithoutYear: false,
            }
        }

        if(this.timezone.dayOfWeek != null) {
            this.type = this.types[1]
        } 
        else if (this.timezone.fixedDateWithoutYear) {
            this.type = this.types[2]
        }
        else if (this.timezone.fixedDate) {
            this.type = this.types[3]
        }
        else {
            this.type = this.types[0]
        }

        this.from.weekDay = this.weekDays[this.timezone.dayOfWeek];
        this.from.day = parseInt(moment(this.timezone.from).format("DD"));
        this.from.month = this.months[parseInt(moment(this.timezone.from).format("MM")) - 1];
        this.from.year = moment(this.timezone.from).format("YYYY");
        this.from.time = moment(this.timezone.from).format("HH:mm");

        this.till.weekDay = this.weekDays[this.timezone.dayOfWeek];
        this.till.day = parseInt(moment(this.timezone.till).format("DD"));
        this.till.month = this.months[parseInt(moment(this.timezone.till).format("MM")) - 1];
        this.till.year = moment(this.timezone.till).format("YYYY");
        this.till.time = moment(this.timezone.till).format("HH:mm");
    }

    submitTimezone() {
        // this.timezone.from = moment(this.timezone.from).format("YYYY-MM-DD HH:mm");
        // this.timezone.till = moment(this.timezone.till).format("YYYY-MM-DD HH:mm");

        var fromDay = this.from.day < 10 ? '0' + this.from.day : this.from.day;
        var fromMonth = this.months.indexOf(this.from.month) + 1 < 10 ? '0' + (this.months.indexOf(this.from.month) + 1) : this.months.indexOf(this.from.month) + 1;

        var tillDay = this.till.day < 10 ? '0' + this.till.day : this.till.day;
        var tillMonth = this.months.indexOf(this.till.month) + 1 < 10 ? '0' + (this.months.indexOf(this.till.month) + 1) : this.months.indexOf(this.till.month) + 1;


        var fts = this.from.time.split(':')
        var fromtimehour = fts[0] < 10 && fts[0].length < 2 ?  '0' + fts[0] : fts[0];
        var fromtime = fromtimehour + ':' + fts[1] + ':00'

        var tts = this.till.time.split(':')
        var tilltimehour = tts[0] < 10 && tts[0].length < 2 ?  '0' + tts[0] : tts[0];
        var tilltime = tilltimehour + ':' + tts[1] + ':00'

        if(this.type == this.types[0]) {
            this.timezone.from = '1900-01-01T' + fromtime
            this.timezone.till = '1900-01-01T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }

        if(this.type == this.types[1]) {
            this.timezone.from = '1900-01-01T' + fromtime
            this.timezone.till = '1900-01-01T' + tilltime
            this.timezone.dayOfWeek = this.weekDays.indexOf(this.from.weekDay);
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }

        if(this.type == this.types[2]) {
            this.timezone.from = '1900-'+ fromMonth +'-'+ fromDay +'T' + fromtime
            this.timezone.till = '1900-'+ tillMonth +'-'+ tillDay +'T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = true;
        }

        if(this.type == this.types[3]) {
            this.timezone.from = this.from.year +'-'+ fromMonth +'-'+ fromDay +'T' + fromtime
            this.timezone.till = this.from.year +'-'+ tillMonth +'-'+ tillDay +'T' + tilltime
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = false;
        }


        if (this.timezone.id === undefined) {
            this.TimezonesService.post(this.timezone).then((result: any) => {
                this.$state.go('settings.timezones.item', { 'id': result.id });
            });
        } else {
            this.TimezonesService.put(this.timezone.id, this.timezone).then(result => {
                this.$state.go('settings.timezones.item', { 'id': result.id }, {reload: true});
            });
        }
    }

    deleteTimezone() {
        this.SweetAlert.swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.TimezonesService.delete(this.timezone.id).then(() => {
                    this.$state.go('^', {reload: true});
                });
            } else {

            }
        });
    }

    startDateBeforeRender($dates) {
        // console.log('startDateBeforeRender');
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0,0,0,0);
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.timezone.from) {
            var activeDate = moment(this.timezone.from).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }
}

export const timezonesItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: TimezonesItemBasicController,
    template: require('./timezones.item.basic.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.item.basic.component.ts